import React from "react";
import {
    ARTICLE_BUTTON_CLASS,
    ARTICLE_CONTAINER_CLASS,
    ARTICLE_TEXT_CONTAINER_CLASS,
    END_QOUTES_CLASS,
    END_QOUTES_CONTAINER_CLASS,
    FIRST_CARD_CONTAINER_CLASS,
    LOGO_CONTAINER_CLASS,
    MAIN_CARD_CONTAINER_CLASS,
    MODEL_IMAGE_CLASS,
    SECOND_CARD_CONTAINER_CLASS,
    START_QOUTES_CLASS,
} from "./Style";
import {
    BlackSimpleArrow,
    NewEndQoutes,
    NewStartQoute,
} from "../../../public/Theme";
import TypographyMontserrat from "../../Atoms/TypographyMontserrat";
import NewTertiaryButton from "../../Atoms/Buttons/NewTertiaryButton";
import { useMediaQuery } from "../../CustomHooks/UseMediaQuery";
import Image from "next/image";
import { sendGTMEvent } from "@next/third-parties/google";
import { GoogleTagManagerEvents } from "../../../common";

const NewsCard = ({ description, image, logo, link, mobileImage }) => {
    const breakpoint = useMediaQuery("500");
    const imageSrc = breakpoint ? mobileImage?.url : image?.url;
    return (
        <div className={MAIN_CARD_CONTAINER_CLASS}>
            <div className={FIRST_CARD_CONTAINER_CLASS}>
                <div className={LOGO_CONTAINER_CLASS}>
                    <Image
                        alt="brand-logo"
                        height={500}
                        width={500}
                        src={logo?.url}
                        className={"h-1/2 lg:h-4/5"}
                    />
                </div>
                <div className={ARTICLE_CONTAINER_CLASS}>
                    <div className={ARTICLE_TEXT_CONTAINER_CLASS}>
                        <Image
                            src={NewStartQoute}
                            className={START_QOUTES_CLASS}
                            alt={"StartQoute"}
                            loading="lazy"
                            height={30}
                            width={30}
                        />
                        <TypographyMontserrat
                            align={"left"}
                            size={"3xl"}
                            text={description}
                        />
                        <div className={END_QOUTES_CONTAINER_CLASS}>
                            <Image
                                width={30}
                                height={30}
                                src={NewEndQoutes}
                                className={END_QOUTES_CLASS}
                                alt={"EndQoutes"}
                                loading="lazy"
                            />
                        </div>
                    </div>
                    <NewTertiaryButton
                        href={link}
                        className={ARTICLE_BUTTON_CLASS}
                        text={"READ THE ARTICLE"}
                        image={BlackSimpleArrow}
                        onClick={() =>
                            sendGTMEvent({
                                event: GoogleTagManagerEvents.navigationInteractions,
                                place: "NewsSection",
                                "menu-name": "NewsSection",
                            })
                        }
                    />
                </div>
            </div>
            <div className={SECOND_CARD_CONTAINER_CLASS}>
                <Image
                    quality={100}
                    loading="lazy"
                    alt="model-image"
                    height={100}
                    width={100}
                    className={MODEL_IMAGE_CLASS}
                    src={imageSrc}
                    unoptimized
                />
            </div>
        </div>
    );
};

export default NewsCard;
